import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../../../partials/aside/Sidebar";
import httpService from "../../../../../services/httpServices/httpServices";
import helpersNumbers from "../../../../../helpers/numbers";
import helperSpinner from "../../../../../helpers/spinner";

function AllBannerDeleted() {
  const [
    allAdvertiseBannerDeletedUserTag,
    setAllAdvertiseBannerDeletedUserTag,
  ] = useState();

  useEffect(() => {
    getAllAdvertiseBannerDeletedUser();
  }, []);

  const getAllAdvertiseBannerDeletedUser = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const allAdvertiseBannerDeletedUser =
      await sendRequestGetAllAdvertiseBannerDeletedUser();
    setAllAdvertiseBannerDeletedUserTag(
      generateAllAdvertiseBannerDeletedUserTag(allAdvertiseBannerDeletedUser)
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  };

  const generateConfirmTag = (confirm) => {
    let classNameConfirmAdvertise;
    let textConfirmAdvertise;
    switch (confirm) {
      case 0:
        classNameConfirmAdvertise = "warning";
        textConfirmAdvertise = "در حال بررسی";
        break;
      case 1:
        classNameConfirmAdvertise = "success";
        textConfirmAdvertise = "تایید شده";
        break;
      case 2:
        classNameConfirmAdvertise = "danger";
        textConfirmAdvertise = "رد شده";
        break;
    }

    return [classNameConfirmAdvertise, textConfirmAdvertise];
  };

  const generateAllAdvertiseBannerDeletedUserTag = (
    allAdvertiseBannerDeletedUser
  ) => {
    return allAdvertiseBannerDeletedUser.map(
      (advertiseBannerDeletedUser, index) => {
        let classNameStateAdvertise = advertiseBannerDeletedUser.adv_active
          ? "success"
          : "danger";
        let textStateAdvertise = advertiseBannerDeletedUser.adv_active
          ? "فعال"
          : "غیر فعال";
        const [classNameConfirmAdvertise, textConfirmAdvertise] =
          generateConfirmTag(advertiseBannerDeletedUser.adv_confirm);

        return (
          <tr>
            <td>{helpersNumbers.toPersianNum(index + 1)}</td>
            <td>
              {helpersNumbers.toPersianNum(advertiseBannerDeletedUser.adv_id)}
            </td>
            <td>
              {helpersNumbers.toPersianNum(
                advertiseBannerDeletedUser.adv_user_id
              )}
            </td>
            <td>
              {helpersNumbers.toPersianNum(
                advertiseBannerDeletedUser.adv_campaign_id
              )}
            </td>
            <td>
              {helpersNumbers.toPersianNum(
                advertiseBannerDeletedUser.adv_created_at
              )}
            </td>
            <td>
              {helpersNumbers.toPersianNum(
                advertiseBannerDeletedUser.adv_updated_at
              )}
            </td>
            <td>
              <div className="text-center">
                <span className={`badge badge-${classNameStateAdvertise} `}>
                  {textStateAdvertise}
                </span>
              </div>
            </td>
            <td>
              <div className="text-center">
                <span className={`badge badge-${classNameConfirmAdvertise}`}>
                  {textConfirmAdvertise}
                </span>
              </div>
            </td>
            <td>
              <div>
                <span>
                  <Link
                    to={`/advertise/manage/banner/all/deleted/${advertiseBannerDeletedUser.adv_id}`}
                    className="btn btn-info"
                  >
                    <i className="fa fa-info"></i>
                  </Link>
                </span>
              </div>
            </td>
          </tr>
        );
      }
    );
  };

  const sendRequestGetAllAdvertiseBannerDeletedUser = async () => {
    const headersRequest = getHeaderForRequest();
    let allAdvertiseBannerUser;
    try {
      allAdvertiseBannerUser = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/advertise/manage/banner/deleted",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return allAdvertiseBannerUser.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  تمامی تبلیغات بنری حذف شده
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="text-left">
                <Link
                  to="/advertise/manage/banner/all"
                  className="btn btn-primary"
                >
                  <span className="pl-2">بازگشت</span>
                  <span>
                    <i className="fa fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              <div className="table-responsive pt-1">
                <table className="table table-bordered table-dark tbl-td-white-space table-hover">
                  <thead>
                    <tr>
                      <td>#</td>
                      <td>شماره تبلیغ</td>
                      <td>شماره کاربری</td>
                      <td>شماره کمپین</td>
                      <td>تاریخ ایجاد</td>
                      <td>تاریخ بروزرسانی</td>
                      <td>وضعیت</td>
                      <td>بررسی</td>
                      <td>عملیات</td>
                    </tr>
                  </thead>
                  <tbody>{allAdvertiseBannerDeletedUserTag}</tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AllBannerDeleted;
